/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect } from 'react'
import { useIntl } from 'react-intl'
import { PageLink, PageTitle, useLayout } from '../../../_metronic/layout/core'
import { TablesWidgetBlacklistIP } from '../../../_metronic/partials/widgets/_new/tables/TablesWidgetBlacklistIP'

const BlackListIP: FC = () => (
  <>
    <div className='row g-5 g-xl-10 mb-5 mb-xl-10'>
      <div className='col-lg-12'>
        <TablesWidgetBlacklistIP className='card-xxl-stretch mb-5 mb-xl-10' />
      </div>
    </div>
  </>
)

const myBreadCrumbs: Array<PageLink> = [
  {
    title: 'Home',
    path: '/dashboard',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
];

const BlackListIPWrapper: FC = () => {
  const intl = useIntl()
  const { setRightTolbar } = useLayout();

  useEffect(() => {
    setRightTolbar("blacklistip")
  }, []);

  return (
    <>
      <PageTitle breadcrumbs={myBreadCrumbs}>{intl.formatMessage({ id: 'PAGE.BLACKLIST_VENDOR', defaultMessage: 'Blacklist Vendor' })}</PageTitle>
      <BlackListIP />
    </>
  )
}

export { BlackListIPWrapper }